import React from "react";
import { useTranslation } from "react-i18next";
import DynamicProductComparison from "./ProductComparison";
import { smartRingsData } from "./deta-ProductComparison/smartRingsData";
import { smartRingTranslations } from "./deta-ProductComparison/smartRingTranslations";

const SmartRingComparison: React.FC = () => {
    const { i18n } = useTranslation();
    const lang = (i18n.language || "fa").split("-")[0];
    const langKey = (["fa", "en", "ar", "tr"].includes(lang) ? lang : "fa") as keyof typeof smartRingTranslations;
    const t = smartRingTranslations[langKey] || smartRingTranslations.fa;

    return (
        <DynamicProductComparison
            title={t.title}
            subtitle={t.subtitle}
            description={t.description}
            data={smartRingsData}
            defaultCategory="medical"
        />
    );
};

export default SmartRingComparison;
